var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "expertOptions",
      staticClass: "d-flex flex-column gap-4",
      model: {
        value: _vm.isValid,
        callback: function ($$v) {
          _vm.isValid = $$v
        },
        expression: "isValid",
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex gap-2 justify-space-between items-center" },
        [
          _c("h3", { staticClass: "text-h6" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("editor.ragTopic.newResourceForm.expertMode.headers")
                ) +
                " "
            ),
          ]),
          _c("BtnSquare", {
            attrs: { preset: "default", icon: "mdi-plus", small: "" },
            on: { click: _vm.addHeader },
            scopedSlots: _vm._u(
              [
                _vm.showHeaderLabel
                  ? {
                      key: "default",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "editor.ragTopic.newResourceForm.expertMode.addHeader"
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      !_vm.headers.length
        ? _c("p", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "editor.ragTopic.newResourceForm.expertMode.headersEmpty"
                  )
                ) +
                " "
            ),
          ])
        : _c(
            "v-expansion-panels",
            {
              model: {
                value: _vm.panelOpen,
                callback: function ($$v) {
                  _vm.panelOpen = $$v
                },
                expression: "panelOpen",
              },
            },
            _vm._l(_vm.headers, function (header, i) {
              return _c(
                "v-expansion-panel",
                { key: i },
                [
                  _c("v-expansion-panel-header", [
                    _c(
                      "span",
                      {
                        staticClass: "text-truncate",
                        staticStyle: { "font-family": "monospace" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              header.key ||
                                `<${_vm.$t(
                                  "editor.ragTopic.newResourceForm.expertMode.empty"
                                )}>`
                            ) +
                            ": " +
                            _vm._s(
                              header.value ||
                                `<${_vm.$t(
                                  "editor.ragTopic.newResourceForm.expertMode.empty"
                                )}>`
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t(
                            "editor.ragTopic.newResourceForm.expertMode.headerKey"
                          ),
                          rules: _vm.makeRules("key"),
                          outlined: "",
                          dense: "",
                        },
                        on: { input: _vm.triggerUpdate },
                        model: {
                          value: header.key,
                          callback: function ($$v) {
                            _vm.$set(header, "key", $$v)
                          },
                          expression: "header.key",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t(
                            "editor.ragTopic.newResourceForm.expertMode.headerValue"
                          ),
                          rules: _vm.makeRules("value"),
                          outlined: "",
                          dense: "",
                        },
                        on: { input: _vm.triggerUpdate },
                        model: {
                          value: header.value,
                          callback: function ($$v) {
                            _vm.$set(header, "value", $$v)
                          },
                          expression: "header.value",
                        },
                      }),
                      _vm.isBasicAuth(header)
                        ? _c(
                            "div",
                            { staticClass: "basic-auth-util mb-4" },
                            [
                              _c("h3", { staticClass: "mb-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "editor.ragTopic.newResourceForm.expertMode.basicAuth"
                                    )
                                  )
                                ),
                              ]),
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("common.username"),
                                  outlined: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.util.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.util, "username", $$v)
                                  },
                                  expression: "util.username",
                                },
                              }),
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("common.password"),
                                  outlined: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.util.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.util, "password", $$v)
                                  },
                                  expression: "util.password",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "BtnSquare",
                        {
                          attrs: {
                            icon: "mdi-trash-can-outline",
                            preset: "outlined-white",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteHeader(header.key)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.remove")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "d-flex gap-4 justify-space-between items-baseline" },
        [
          _c("h3", { staticClass: "text-h6" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "editor.ragTopic.newResourceForm.expertMode.jsonEditor"
                  )
                ) +
                " "
            ),
          ]),
          _vm.isSpecific
            ? _c("v-switch", {
                staticClass: "mt-0 pt-0",
                attrs: {
                  label: _vm.$t(
                    "editor.ragTopic.newResourceForm.expertMode.previewGlobal"
                  ),
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "editor.ragTopic.newResourceForm.expertMode.previewGlobalHint"
                  ),
                  inset: "",
                  color: "green",
                },
                model: {
                  value: _vm.showMergedResult,
                  callback: function ($$v) {
                    _vm.showMergedResult = $$v
                  },
                  expression: "showMergedResult",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.showMergedResult
        ? _c("v-textarea", {
            staticClass: "mb-2",
            attrs: {
              label: "JSON",
              outlined: "",
              "auto-grow": "",
              rules: _vm.rules.json,
            },
            model: {
              value: _vm.valueAsString,
              callback: function ($$v) {
                _vm.valueAsString = $$v
              },
              expression: "valueAsString",
            },
          })
        : _c("v-textarea", {
            staticClass: "mb-2",
            attrs: {
              label: "JSON",
              outlined: "",
              "auto-grow": "",
              "persistent-hint": "",
              hint: _vm.$t(
                "editor.ragTopic.newResourceForm.expertMode.previewJSONHint"
              ),
              readonly: "",
              rules: _vm.rules.json,
            },
            model: {
              value: _vm.mergedResult,
              callback: function ($$v) {
                _vm.mergedResult = $$v
              },
              expression: "mergedResult",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }